import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable, catchError, map, throwError } from 'rxjs';
import { AuthService } from '../_services/auth/auth.service';

/**
 * Interceptor HTTP que detecta respuestas sin cabecera de autorización válida.
 *
 * Inspecciona las respuestas entrantes y, cuando el cuerpo indica el error
 * `Missing authorization header`, cierra la sesión del usuario mediante el
 * {@link AuthService}. Propaga los errores sin alterarlos.
 */
@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
  ) {}

  /**
   * Intercepta la respuesta de la petición y cierra la sesión si falta la cabecera de autorización.
   * @param request - Petición HTTP saliente a interceptar.
   * @param next - Manejador que continúa la cadena de interceptores.
   * @returns Flujo observable con los eventos HTTP; los errores se reenvían sin modificarse.
   */
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      map(event => {
        if (event instanceof HttpResponse) {
          const body = event.body;
          if (body && body.error && body.message === 'Missing authorization header') {
            this.handleAuthError();
          }
        }
        return event;
      }),
      catchError(err => {
        return throwError(() => err);
      })
    );
  }

  /**
   * Cierra la sesión activa del usuario al detectar una respuesta sin autorización.
   */
  private handleAuthError() {
    this.authService.logout();
  }

}
